import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { CardBrand } from '@square/dashboard-data/models/squareup/beemo/api/v2/models/tender';

// https://prototype.sqprod.co/#/docs/squareup.bills.Tender.Method

const Card = ProtoBaseModel.extend({
  panSuffix: attr(String),
  entryMethod: attr(String),
  brand: attr(CardBrand)
});
const CardTender = ProtoBaseModel.extend({
  card: attr(Card)
});
export default ProtoBaseModel.extend({
  cardTender: attr(CardTender)
});